(function(){
  var RULES=[
    {a:'Front Frame — 1',s:'YC.JG.ZS006589',map:'FFM1#5',missing:'FFM1#5',legacy:'5'},
    {a:'Front Frame — 1',s:'YC.XC.XX001498',map:'FFM1#23 / FFM1#29',missing:'FFM1#29',legacy:'24-5'},
    {a:'Front Frame — 1',s:'YC.ST.LL000730',map:'FFM1#6 / FFM1#9 / FFM1#30',missing:'FFM1#30',legacy:'25'},
    {a:'Front Frame — 1',s:'YC.JG.YZ001069',map:'FFM1#31',missing:'FFM1#31',legacy:'26'},
    {a:'Front Frame — 1',s:'YC.JG.ZS006715',map:'FFM1#32',missing:'FFM1#32',legacy:'27'},
    {a:'Front Frame — 2',s:'YC.JG.ZS006626',map:'FFM2#5',missing:'FFM2#5',legacy:'3-2'},
    {a:'Front Frame — 2',s:'BC.AG.SS001093',map:'FFM2#29',missing:'FFM2#29',legacy:'26'},
    {a:'Front Frame — 2',s:'YC.WJ.LL000211',map:'FFM2#30',missing:'FFM2#30',legacy:'27'},
    {a:'Front Frame — 2',s:'YC.JG.MQ003804',map:'FFM2#31',missing:'FFM2#31',legacy:'28'},
    {a:'M1/M3 Small Aircraft Arm',s:'YC.JG.ZS006701',map:'M1M3#17',missing:'M1M3#17',legacy:'16'},
    {a:'M1/M3 Small Aircraft Arm',s:'YC.ST.LL000667',map:'M1M3#25 / M1M3#28',missing:'M1M3#28',legacy:'25'},
    {a:'M1/M3 Small Aircraft Arm',s:'YC.JG.MY001907',map:'M1M3#29',missing:'M1M3#29',legacy:'26'},
    {a:'M1/M3 Small Aircraft Arm',s:'YC.WJ.LL000232',map:'M1M3#9 / M1M3#30',missing:'M1M3#30',legacy:'27'},
    {a:'Spray Lance — 2',s:'YC.WJ.LL000232',map:'MKA#21',missing:'MKA#21',legacy:'21'},
    {a:'Spray Tank — Tank',s:'YC.JG.CS000050',map:'STS1#1',missing:'STS1#1',legacy:'1',unnumbered:true}
  ];
  function sku(v){return String(v||'').trim().toUpperCase();}
  function ruleFor(row){
    if(!row)return null;
    var material=row.querySelector('.t100parts__material');
    var s=sku(material&&material.textContent),a=row.dataset.assembly||'';
    return RULES.find(function(r){return r.a===a&&r.s===s;})||null;
  }
  function decorate(root){
    root.querySelectorAll('[data-part-row]').forEach(function(row){
      var r=ruleFor(row);if(!r)return;
      row.dataset.t100SourceGap='true';
      if(row.querySelector('.t100parts__calloutNote'))return;
      var host=row.querySelector('.t100parts__item')||row.querySelector('[data-row-item]')||row;
      var note=document.createElement('span');note.className='t100parts__calloutNote';
      note.textContent='Verified mapping: '+r.map+' · '+(r.unnumbered?'source image is unnumbered':r.missing+' missing from source diagram');
      host.appendChild(note);
    });
  }
  function setup(root){
    var context=root.querySelector('[data-t100-diagram-sub]');
    var notice=root.querySelector('[data-t100-source-gap-notice]');
    if(!notice){
      notice=document.createElement('div');notice.className='t100parts__sourceGap';notice.dataset.t100SourceGapNotice='';notice.hidden=true;notice.setAttribute('role','status');notice.setAttribute('aria-live','polite');
      if(context)context.insertAdjacentElement('afterend',notice);else root.prepend(notice);
    }
    function update(){
      decorate(root);
      var row=root.querySelector('[data-part-row].is-selected'),r=ruleFor(row);
      if(!r){notice.hidden=true;notice.textContent='';return;}
      var s=sku(row.querySelector('.t100parts__material')&&row.querySelector('.t100parts__material').textContent);
      notice.textContent=s+' maps to '+r.map+'. '+(r.unnumbered?'The supplied source image is unnumbered, so STS1#1 cannot be drawn as a verified marker yet.':'The supplied source diagram does not display '+r.missing+', so a verified yellow marker/highlight cannot be shown for that location yet.')+' The material-number mapping is preserved; highlighted media is waiting for a corrected source diagram.';
      notice.hidden=false;
    }
    var observer=new MutationObserver(function(){window.requestAnimationFrame(update);});
    var rows=root.querySelector('[data-t100-rows]'),hots=root.querySelector('[data-t100-hotspots]');
    if(rows)observer.observe(rows,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    if(hots)observer.observe(hots,{childList:true,subtree:true});
    root.addEventListener('click',function(){setTimeout(update,0);},true);
    var sel=root.querySelector('[data-t100-assembly]');if(sel)sel.addEventListener('change',function(){setTimeout(update,0);});
    var search=root.querySelector('.t100parts__search');if(search)search.addEventListener('input',function(){setTimeout(update,0);},true);
    update();
  }
  function init(){document.querySelectorAll('.t100parts[data-t100parts]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
